export default __webpack_public_path__ + "static/media/ghsi-cancellation-and-refund-policy.e31d4993.jpg";